// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  border-bottom: 1px solid var(--bg-color);
  cursor: pointer;
}
ion-item ion-label {
  font-family: var(--font);
  font-weight: 600;
  font-size: 1.3rem;
}

.check-in ion-label {
  margin-left: 10px;
}
.check-in ion-thumbnail {
  --size: 10%;
  --border-radius: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/checkin/checkin.page.scss"],"names":[],"mappings":"AAAA;EACI,wCAAA;EACA,eAAA;AACJ;AACI;EACI,wBAAA;EAA0B,gBAAA;EAC1B,iBAAA;AAER;;AAGI;EACI,iBAAA;AAAR;AAEI;EACI,WAAA;EACA,oBAAA;AAAR","sourcesContent":["ion-item{\n    border-bottom: 1px solid var(--bg-color);\n    cursor: pointer;\n    \n    ion-label{\n        font-family: var(--font); font-weight: 600;;\n        font-size: 1.3rem;\n    }\n}\n\n.check-in {\n    ion-label {\n        margin-left: 10px;\n    }\n    ion-thumbnail {\n        --size: 10%;\n        --border-radius: 2px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
